import React, { useMemo, useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
// import { data } from './copy tabs/makeData';
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import {
  useForm,
  useFieldArray,
  useFormContext,
  Controller,
  useWatch,
} from "react-hook-form";
import Grid from "@mui/material/Grid";
import axios from "../../../../../../api/axios";
import CustomAlert from "../../../../../../components/widgets/CustomAlert";
import { Stack, ListItemIcon, Box, Snackbar, Alert } from "@mui/material";
import { estimateNozzle, calculateNozzle } from "../../API`s/pv/sqliteApi";

// import { Type, Service, Size, Flange_Rating, Sch_thk } from "./select_options/NozzleTab_Select"
import {
  getColumns,
  ResultColumns,
  columns,
  GeometryDataColumns,
  MaterialDataColumns,
  EstimationColumns,
} from "./columnNames/NozzleColumns";
import { computeNozzleUID } from "../../../../../../utils/pvUID";
import InputTable from "./InputTable";
import GeometryDataTable from "./GeometryDataTable";
import ResultTable from "./ResultTable";
import { EstimationTable } from "./EstimationTable";
import BomTable from "../../../../AllEquipments/CommonFeatures/EstimationTab/BomTable";
import {
  buildNozzleBomDgv8,
  buildBomFromDgv8,
} from "../bomHelpers";
import { usePVContext } from "../PVContext";

const initialErrorState = {
  calculationError: false,
  estimationError: false,
};

//The Main Function
const NozzleTab = (props) => {
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity (success or error)
  const [openSnackbar, setOpenSnackbar] = useState(false); // Control Snackbar visibility

  const { reRender } = props;

  console.log(ResultColumns, columns);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState(initialErrorState);
  const [resultVisibility, setresultVisibility] = useState(false);
  const [geometryDataVisibility, setGeometryDataVisibility] = useState(false);
  const { control, setValue, getValues } = useFormContext();
  const { currentRevision, revisionLoadVersion } = usePVContext();
  const [estimationVisibility, setEstimationDataVisibility] = useState(false);
  const [bomVisibility, setBomVisibility] = useState(false);
  const [nozzleBomData, setNozzleBomData] = useState([]);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "DataGridView1",
  });
  const watchedNozzleRows = useWatch({
    control,
    name: "DataGridView1",
  });
  const {
    fields: geometryDataFields,
    append: geometryDataAppend,
    remove: geometryDataRemove,
  } = useFieldArray({
    control,
    name: "DataGridView10",
  });
  const watchedGeometryRows = useWatch({
    control,
    name: "DataGridView10",
  });

  const [openAlert, setOpenAlert] = useState(false);
  const [AlertContent, setAlertContent] = useState({
    severity: "",
    message: "",
  });

  const handleCreateNewRow = (values) => {
    append({
      UID: "",
      Mark: "",
      Service: "",
      Size: "",
      Type: "",
      "Flange Rating": "",
      "Sch/Thk": "",
      "Weld Detail": "",
      "Nozzle Weld (A)": "",
      "Inside Weld (B)": "",
      "Pad Weld (C)": "",
      "Outside Proj": "",
      "Inside Proj": "",
      "Pad OD": "",
      "Pad Thk": "",
    });
    geometryDataAppend({
      "Dist From DL": "",
      Orientation: "",
      "Dist From CL (+/-)": "",
      Direction: "",
      Location: "",
      "Nozzle Material": getValues("ComboBox12"),
      "Flange Material": getValues("ComboBox13"),
      "Pad Material": getValues("ComboBox14"),
    });
  };
  const handleDeleteRow = (index) => {
    remove(index);
    geometryDataRemove(index);
  };

  console.log("fields", fields, geometryDataFields);

  const handleSaveCell = (cell, value, datagrid) => {
    console.log(`${datagrid}.${cell.row.index}.${cell.column.id}`, value);

    // Changes in Diameter applied throughout Table. And in the other tabs
    setValue(`${datagrid}.${cell.row.index}.${cell.column.id}`, value);
    if (datagrid === "DataGridView1" && cell.column.id === "Size") {
      reRender();
    }
    // Auto-generate UID when Mark changes
    if (datagrid === "DataGridView1" && cell.column.id === "Mark") {
      const projectTag = getValues("TextBox48") || "";
      const uid = computeNozzleUID(value, projectTag);
      setValue(`${datagrid}.${cell.row.index}.UID`, uid);
      reRender();
    }
  };

  const toggleVisibility = (makeVisibile) => {
    setGeometryDataVisibility(false);
    setEstimationDataVisibility(false);
    setresultVisibility(false);
    setBomVisibility(false);
    makeVisibile();
  };

  const showResults = async () => {
    const data = getValues();
    setIsLoading(true);
    toggleVisibility(() => setresultVisibility(true));
    const response = await calculateNozzle(data);
    setIsLoading(false);
    if (response.error) {
      setError((prev) => ({ ...prev, calculationError: true }));
    } else {
      console.log(response.data.DataGridView3);
      setValue("DataGridView3", response.data.DataGridView3);
      setError(initialErrorState);
    }
  };

  const showEstimation = async () => {
    const data = getValues();
    setGeometryDataVisibility(false);
    setresultVisibility(false);
    setEstimationDataVisibility(true);
    setIsLoading(true);

    // Pre-populate any missing UIDs before sending to API
    const nozzleRows = data.DataGridView1 || [];
    const projectTag = data.TextBox48 || "";
    nozzleRows.forEach((row, i) => {
      if (!row.UID && row.Mark) {
        const uid = computeNozzleUID(row.Mark, projectTag);
        setValue(`DataGridView1.${i}.UID`, uid);
        row.UID = uid;
      }
    });

    try {
      const response = await estimateNozzle(data);
      console.log({ response });
      if (response.error) {
        console.error(response.error);
        setError((prev) => ({ ...prev, estimationError: true }));
        return;
      } else {
        // Preserve UIDs from original rows if the API response strips them
        const returnedRows = response.data || [];
        const mergedRows = returnedRows.map((row, i) => ({
          ...row,
          UID:
            nozzleRows[i]?.UID || computeNozzleUID(row.Mark, projectTag) || "",
        }));
        setValue("DataGridView2", mergedRows);
      }
      setIsLoading(false);
      setError(initialErrorState);
    } catch (error) {
      setError((prev) => ({ ...prev, estimationError: true }));
    }
  };

  const handleNozzleBom = async () => {
    const data = getValues();
    // Show the BOM panel immediately (it fills in as soon as the
    // estimation — if needed — resolves). Don't collapse the Calculate /
    // Estimation panels; they can stay visible alongside the BOM.
    setBomVisibility(true);
    setIsLoading(true);

    const nozzleMaterial = getValues("ComboBox12");
    const flangeMaterial = getValues("ComboBox13");
    const padMaterial = getValues("ComboBox14");

    const buildBom = (rows, estRows) =>
      buildBomFromDgv8(
        buildNozzleBomDgv8(
          rows,
          estRows,
          nozzleMaterial,
          flangeMaterial,
          padMaterial,
        ),
      );

    let nozzleRows = data.DataGridView1 || [];
    let nozzleEstRows = data.DataGridView2 || [];

    // TEMP DIAGNOSTIC - remove after verifying first-click fix
    console.log("[BOM noz] source rows:", nozzleRows.length, "est rows:", nozzleEstRows.length);

    // Build BOM right away from whatever is in the form so the first
    // click is never empty (weights fill in when estimation runs).
    const firstBom = buildBom(nozzleRows, nozzleEstRows);
    console.log("[BOM noz] first build rows:", firstBom.length);
    setNozzleBomData(firstBom);

    // Auto-run estimation if it hasn't been done yet (no weights)
    if (
      !nozzleEstRows.length ||
      nozzleRows.some(
        (_, i) =>
          !(nozzleEstRows[i] && nozzleEstRows[i]["Pipe Weight"]) &&
          !(nozzleEstRows[i] && nozzleEstRows[i]["Flange Weight"]),
      )
    ) {
      const projectTag = data.TextBox48 || "";
      nozzleRows.forEach((row, i) => {
        if (!row.UID && row.Mark) {
          const uid = computeNozzleUID(row.Mark, projectTag);
          setValue(`DataGridView1.${i}.UID`, uid);
          row.UID = uid;
        }
      });

      const fresh = getValues();
      nozzleEstRows = fresh.DataGridView2 || nozzleEstRows;
      const response = await estimateNozzle(data);
      if (!response.error) {
        const returnedRows = response.data || [];
        const mergedRows = returnedRows.map((row, i) => ({
          ...row,
          UID:
            nozzleRows[i]?.UID ||
            computeNozzleUID(row.Mark, projectTag) ||
            "",
        }));
        nozzleEstRows = mergedRows;
        setValue("DataGridView2", mergedRows);
      }
    }

    // Always rebuild from the freshest form state so the first click
    // populates the table (no second press required).
    const freshAfter = getValues();
    const finalRows = freshAfter.DataGridView1 || nozzleRows;
    const finalEst = freshAfter.DataGridView2 || nozzleEstRows;
    const finalBom = buildBom(finalRows, finalEst);
    console.log("[BOM noz] final build rows:", finalBom.length);
    setNozzleBomData(finalBom);

    setIsLoading(false);
  };

  // Guarantee the BOM is populated on the first press even if the click
  // handler ran before the form rows were flushed to state: rebuild the
  // table from live form values whenever the panel becomes visible.
  useEffect(() => {
    if (!bomVisibility) return;
    const data = getValues();
    const rows = data.DataGridView1 || [];
    const estRows = data.DataGridView2 || [];
    const bom = buildBomFromDgv8(
      buildNozzleBomDgv8(
        rows,
        estRows,
        getValues("ComboBox12"),
        getValues("ComboBox13"),
        getValues("ComboBox14"),
      ),
    );
    console.log("[BOM noz] effect rows:", bom.length, "of", rows.length, "source");
    setNozzleBomData(bom);
  }, [bomVisibility]);

  const showGeometryData = async () => {
    toggleVisibility(() => setGeometryDataVisibility(true));
  };
  useEffect(() => {
    props.pidState === 2 && handleGetPID();
    props.pidState === 4 && handleSavePID();
  }, [props]);
  const handleGetPID = async () => {
    const result = await axios.get("/pressure_vessel_table/nozzle-pid");
    console.log(result.data.dataNozzles);
    const nozzlesPID = result.data.dataNozzles;
    nozzlesPID.forEach((nozzle) => {
      append({
        UID: "",
        Mark: nozzle.Tag,
        Service: nozzle.Service,
        Size: nozzle.Size.replace('"', ""),
        Type: "WN RF",
        "Flange Rating": "",
        "Sch/Thk": nozzle.Schedule,
        "Weld Detail": "",
        "Nozzle Weld (A)": "",
        "Inside Weld (B)": "",
        "Pad Weld (C)": "",
        "Outside Proj": "",
        "Inside Proj": "",
        "Pad OD": "",
        "Pad Thk": "",
        PnID: nozzle.PnPID,
      });
    });
  };
  const handleSavePID = () => {
    const reqBody = (watchedNozzleRows ?? []).map((field) => {
      return {
        PnID: field.PnID,
        Tag: field.Mark,
        Size: field.Size.concat("", '"'),
      };
    });
    axios.post("/pressure_vessel_table/nozzle-pid", reqBody);
  };
  const getDBData = async (speratedData) => {
    const allTables = await window.electron.db.getAllTables("pv");
    // const allTables = response && response.success ? response.data : {};
    console.log("allTables", allTables);

    const pipeKey = "#Tube & Pipe#Conduits#Pipes#ASME B16 Pipe";
    const getFlangeKeyByRating = (ratingRaw) => {
      const digits = String(ratingRaw ?? "")
        .replace(/[^\d]/g, "")
        .trim();
      const rating = digits || "150";
      return `#Tube & Pipe#Fittings#Flanges#Flange WNRF ${rating}`;
    };

    const pipeTable = Array.isArray(allTables[pipeKey])
      ? allTables[pipeKey]
      : [];

    const results = [];
    // Define DGV10 columns to exclude
    const DGV10Columns = [
      "Dist From DL",
      "Orientation",
      "Dist From CL (+/-)",
      "Direction",
      "Location",
    ];

    for (const item of speratedData) {
      // const component = item.Component?.toLowerCase();
      let matchedPipeRow = null;
      let matchedFlangeRow = null;

      // if (component === "pipe") {
      const ndRaw = item["Size"].replace(/\s+/g, "").trim();

      const snRaw = item["Sch/Thk"].replace(/\s+/g, "").trim();
      if (!ndRaw || !snRaw) {
        console.warn("Skipping pipe, missing ND or SN:", item);
        continue;
      }

      matchedPipeRow = pipeTable.find(
        (row) => row.ND === String(ndRaw) && String(row.SN) === String(snRaw),
      );
      // } else if (component === "flange") {
      const sizeRaw = item["Size"].replace(/\s+/g, "").trim();
      console.log("sizeRaw:", sizeRaw);

      if (!sizeRaw) {
        console.warn("Skipping flange, missing Size:", item);
        continue;
      }

      const flangeKey = getFlangeKeyByRating(item["Flange Rating"]);
      const fallbackFlangeKey = getFlangeKeyByRating("150");
      const flangeTable = Array.isArray(allTables[flangeKey])
        ? allTables[flangeKey]
        : Array.isArray(allTables[fallbackFlangeKey])
          ? allTables[fallbackFlangeKey]
          : [];

      matchedFlangeRow = flangeTable.find(
        (row) => row["ND"] === String(sizeRaw),
      );
      console.log("matchedRow:", matchedFlangeRow);
      // }

      //✅ Filter out DGV10 columns from item
      const filteredItem = Object.keys(item).reduce((acc, key) => {
        if (!DGV10Columns.includes(key)) {
          acc[key] = item[key];
        }
        return acc;
      }, {});

      results.push({
        ...filteredItem,
        Pipe: matchedPipeRow ? [{ ...matchedPipeRow }] : [],
        Flange: matchedFlangeRow ? [{ ...matchedFlangeRow }] : [],
      });
    }

    return results;
  };

  const onUpdate3d = async () => {
    setSnackbarMessage("Update in progress");
    setSnackbarSeverity("info");
    setOpenSnackbar(true);

    const shellData = getValues()?.DataGridView5;
    const orientation = getValues("ComboBox5");
    const diameter = getValues("txtVIDia");
    const data = getValues()?.DataGridView1;
    const geoData = getValues()?.DataGridView10;

    if (!data || data.length === 0) {
      return;
    }

    // ✅ Direct call - returns the array directly
    const DbData = await getDBData(data);

    const allData = DbData.map((row, i) => {
      const merged = { ...geoData[i], ...row };
      console.log(`Row ${i} merged:`, merged);
      return merged;
    });
    const projectTag = getValues("TextBox48") || "";
    const formattedData = {
      data: {
        diameter,
        orientation,
        nozzlesDesign: allData?.map((row, i) => {
          const uid =
            row["UID"] || computeNozzleUID(row["Mark"], projectTag) || "";
          return { ...row, UID: uid, rowNo: i };
        }),
        shellDesignData: shellData,
      },
    };
    console.log("all data ", formattedData);

    let updateResponse = null;
    let updateError = null;
    let updateTimedOut = false;

    try {
      updateResponse = await window.electron.pv.updateNozzle3d(formattedData);
      console.log("response :", updateResponse);
    } catch (error) {
      updateError = error;
      updateTimedOut = String(error?.message ?? error)
        .toLowerCase()
        .includes("timeout");
      console.error("3D update failed:", error);
    }

    if (!updateError) {
      setSnackbarMessage(updateResponse?.message || "Nozzle 3D updated.");
      setSnackbarSeverity(updateResponse?.ok === false ? "error" : "success");
    } else {
      if (updateTimedOut) {
        setSnackbarMessage(
          "Nozzle 3D update is still processing (timeout waiting for response).",
        );
        setSnackbarSeverity("info");
      } else {
        setSnackbarMessage("Nozzle 3D update failed.");
        setSnackbarSeverity("error");
      }
    }
    setOpenSnackbar(true);
  };

  return (
    <div
      // style={{
      //   width: "100%",
      //   minWidth: "610px",
      // }}
      style={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <CustomAlert
        open={openAlert}
        setOpen={setOpenAlert}
        severity={AlertContent.severity}
        message={AlertContent.message}
      />
      <br />
      <Stack spacing={2} direction="row">
        <Button
          size="small"
          color={geometryDataVisibility ? "secondary" : "primary"}
          onClick={() => showGeometryData()}
          variant="contained"
          sx={{
            fontWeight: geometryDataVisibility ? 700 : 600,
            ...(geometryDataVisibility && {
              boxShadow: 2,
            }),
          }}
        >
          Geometry Data
        </Button>
        <Button
          size="small"
          color={resultVisibility ? "secondary" : "primary"}
          onClick={() => showResults()}
          variant="contained"
          sx={{
            fontWeight: resultVisibility ? 700 : 600,
            ...(resultVisibility && {
              boxShadow: 2,
            }),
          }}
        >
          Nozzle Cal
        </Button>

        <Button
          size="small"
          color={estimationVisibility ? "secondary" : "primary"}
          onClick={() => showEstimation()}
          variant="contained"
          sx={{
            fontWeight: estimationVisibility ? 700 : 600,
            ...(estimationVisibility && {
              boxShadow: 2,
            }),
          }}
        >
          Estimation
        </Button>

        <Button
          size="small"
          color={bomVisibility ? "secondary" : "primary"}
          onClick={() => handleNozzleBom()}
          variant="contained"
          sx={{
            fontWeight: bomVisibility ? 700 : 600,
            ...(bomVisibility && {
              boxShadow: 2,
            }),
          }}
        >
          BOM
        </Button>
      </Stack>

      <br />
      <Grid
        container
        spacing={1}
        sx={{
          width: "100%",
          minWidth: 0,
          maxWidth: "100%",
          m: 0,
          overflowX: "hidden",
        }}
      >
        {/* <Grid item xs={6.5}> */}
        <Grid
          item
          xs={12}
          md={
            geometryDataVisibility ||
            resultVisibility ||
            estimationVisibility ||
            bomVisibility
              ? 6.5
              : 12
          }
          sx={{
            minWidth: 0,
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <InputTable
            key={`nozzle-input-${currentRevision}-${revisionLoadVersion}`}
            fields={watchedNozzleRows ?? []}
            handleCreateNewRow={handleCreateNewRow}
            handleDeleteRow={handleDeleteRow}
            handleSaveCell={handleSaveCell}
            isSplitView={
              geometryDataVisibility || resultVisibility || estimationVisibility
            }
          />
          {bomVisibility ? (
            <>
              <br />
              <BomTable data={nozzleBomData} dimensionWidth={50} />
            </>
          ) : (
            <></>
          )}
        </Grid>
        {/* Geometry Data */}
        {geometryDataVisibility ? (
          <Grid
            item
            xs={12}
            md={5.5}
            sx={{
              minWidth: 0,
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            <GeometryDataTable
              key={`nozzle-geometry-${currentRevision}-${revisionLoadVersion}`}
              rows={watchedGeometryRows}
              handleSaveCell={handleSaveCell}
            />
          </Grid>
        ) : (
          <></>
        )}

        {resultVisibility ? (
          <Grid
            item
            xs={12}
            md={5.5}
            sx={{
              minWidth: 0,

              width: {
                xs: "100% !important",
                md: "auto",
              },

              maxWidth: {
                xs: "100% !important",
                md: "45.833333% !important",
              },

              flexBasis: {
                xs: "100% !important",
                md: "45.833333% !important",
              },

              overflow: "hidden",
            }}
          >
            <ResultTable
              isLoading={isLoading}
              isError={error?.calculationError}
            />
          </Grid>
        ) : (
          <></>
        )}

        {estimationVisibility ? (
          <Grid
            item
            xs={12}
            md={5.5}
            sx={{
              minWidth: 0,

              width: {
                xs: "100% !important",
                md: "auto",
              },

              maxWidth: {
                xs: "100% !important",
                md: "45.833333% !important",
              },

              flexBasis: {
                xs: "100% !important",
                md: "45.833333% !important",
              },

              overflow: "hidden",
            }}
          >
            <EstimationTable
              key={`nozzle-estimation-${currentRevision}-${revisionLoadVersion}`}
              isLoading={isLoading}
              isError={error?.estimationError}
            />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NozzleTab;
